import axios from 'axios';

var dropdownClosingEvent = new Event("dropdown-closing");
function init() {
  [].slice
    .call(document.querySelectorAll(".js-reflist-dropdown"))
    .map(function (dropdown) {
      var actionType = dropdown.getAttribute("data-action-type");
      var recordId = dropdown.getAttribute("data-record");
      var listId = dropdown.getAttribute("data-list");
      var content = dropdown.querySelectorAll(".dropdown-content")[0];

      dropdown.addEventListener(
        "dropdown-opening",
        function (e) {
          axios
            .get("/api/reference-lists/get-by-record/" + recordId)
            .then(function (result) {
              result.data.forEach(function (list) {
                var link = document.createElement("a");
                link.classList.add("dropdown-item");

                if (list.entryInserted) {
                  link.setAttribute("disabled", "");
                  var tickSpan = document.createElement("span");
                  tickSpan.classList.add("icon");
                  var tick = document.createElement("i");
                  tick.classList.add("fas", "fa-check");
                  tickSpan.appendChild(tick);
                  link.appendChild(tickSpan);
                } else {
                  link.setAttribute("href", "#");
                  link.addEventListener(
                    "click",
                    function (ce) {
                      ce.preventDefault();
                      if (actionType === "save") {
                        axios
                          .post(
                            "/api/reference-lists/" + list.id + "/add-entry",
                            {
                              recordId: recordId,
                            }
                          )
                          .catch(function (error) {
                            console.log(error);
                          });
                      } else if (actionType === "move") {
                        axios
                          .post(
                            "/api/reference-lists/" + listId + "/move-entry",
                            {
                              recordId: recordId,
                              targetListId: list.id,
                            }
                          )
                          .then(function () {
                            var box = document.getElementById(recordId);
                            if (box) {
                              box.parentNode.removeChild(box);
                            }
                          })
                          .catch(function (error) {
                            console.log(error);
                          });
                      }
                      dropdown.classList.toggle("is-active");
                      dropdown.dispatchEvent(dropdownClosingEvent);
                    },
                    false
                  );
                }

                link.appendChild(document.createTextNode(list.title));
                content.appendChild(link);
              });
            });
        },
        false
      );

      dropdown.addEventListener("dropdown-closing", function (e) {
        while (content.firstChild) {
          content.removeChild(content.firstChild);
        }
      });
    });
  [].slice.call(document.querySelectorAll(".rating")).map(function (rating) {
    var recordId = rating.getAttribute("data-record");
    var listId = rating.getAttribute("data-list");
    var currentRating = rating.getAttribute("data-rating");
    var ratingStars = rating.querySelectorAll(".rating-star");
    [].slice.call(ratingStars).map(function (ratingStar) {
      var rating = ratingStar.getAttribute("data-rating");
      ratingStar.addEventListener(
        "click",
        function (e) {
          axios
            .post("/api/reference-lists/" + listId + "/rate-entry", {
              recordId: recordId,
              rating: rating,
            })
            .then(function () {
              currentRating = rating;
              [].slice.call(ratingStars).map(function (rs) {
                var otherRating = rs.getAttribute("data-rating");
                if (otherRating <= rating) {
                  rs.classList.add("has-text-primary");
                } else {
                  rs.classList.remove("has-text-primary");
                }
              });
            })
            .catch(function (error) {
              console.log(error);
            });
        },
        false
      );
      ratingStar.addEventListener(
        "mouseenter",
        function (e) {
          [].slice.call(ratingStars).map(function (rs) {
            var otherRating = rs.getAttribute("data-rating");
            if (otherRating <= rating) {
              rs.classList.add("has-text-primary");
              rs.classList.remove("has-text-grey-light");
            } else {
              rs.classList.remove("has-text-primary");
              rs.classList.add("has-text-grey-light");
            }
          });
        },
        false
      );
      ratingStar.addEventListener(
        "mouseleave",
        function (e) {
          [].slice.call(ratingStars).map(function (rs) {
            var otherRating = rs.getAttribute("data-rating");
            if (otherRating <= currentRating) {
              rs.classList.add("has-text-primary");
              rs.classList.remove("has-text-grey-light");
            } else {
              rs.classList.remove("has-text-primary");
              // rs.classList.add('has-text-light');
              rs.classList.add("has-text-grey-light");
            }
          });
        },
        false
      );
    });
  });
  document.getElementById("result-list-sorting").onchange = function() {
    window.location.href = this.options[this.selectedIndex].getAttribute('data-target');
  }
}

window.addEventListener("load", init, false);
